import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { browserLanguage, isExternalLink, thfLocaleDefault } from '../../utils/util';

import { ThfPageBlockedUserBaseComponent } from './thf-page-blocked-user-base.component';

export const thfPageBlockedUserButtonLiterals: Object = {
  en: <any> {
    primaryButton: 'Back to home screen',
  },
  es: <any> {
    primaryButton: 'Volver al inicio',
  },
  pt: <any> {
    primaryButton: 'Voltar para o inÃ­cio',
  }
};

/**
 * @docsExtends ThfPageBlockedUserBaseComponent
 *
 * @example
 *
 * <example name="thf-page-blocked-user-basic" title="Totvs Page Blocked User Basic">
 *  <file name="sample-thf-page-blocked-user-basic/sample-thf-page-blocked-user-basic.component.html"> </file>
 *  <file name="sample-thf-page-blocked-user-basic/sample-thf-page-blocked-user-basic.component.ts"> </file>
 * </example>
 *
 * <example name="thf-page-blocked-user-labs" title="Totvs Page Blocked User Labs">
 *  <file name="sample-thf-page-blocked-user-labs/sample-thf-page-blocked-user-labs.component.html"> </file>
 *  <file name="sample-thf-page-blocked-user-labs/sample-thf-page-blocked-user-labs.component.ts"> </file>
 * </example>
 *
 * <example name="thf-page-blocked-user-exceeded-attempts" title="Totvs Page Blocked User Exceeded Attempts">
 *  <file name="sample-thf-page-blocked-user-exceeded-attempts/sample-thf-page-blocked-user-exceeded-attempts.component.html"> </file>
 *  <file name="sample-thf-page-blocked-user-exceeded-attempts/sample-thf-page-blocked-user-exceeded-attempts.component.ts"> </file>
 * </example>
 *
 * <example name="thf-page-blocked-user-expired-password" title="Totvs Page Blocked User Expired Password">
 *  <file name="sample-thf-page-blocked-user-expired-password/sample-thf-page-blocked-user-expired-password.component.html"> </file>
 *  <file name="sample-thf-page-blocked-user-expired-password/sample-thf-page-blocked-user-expired-password.component.ts"> </file>
 * </example>
 */

@Component({
  selector: 'thf-page-blocked-user',
  templateUrl: './thf-page-blocked-user.component.html'
})

export class ThfPageBlockedUserComponent extends ThfPageBlockedUserBaseComponent implements OnInit {

  literals = {
    ...thfPageBlockedUserButtonLiterals[thfLocaleDefault],
    ...thfPageBlockedUserButtonLiterals[browserLanguage()],
  };

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    super();
  }

  ngOnInit() {
    this.checkingForRouteMetadata(this.activatedRoute.snapshot.data);
  }

  navigateTo(url: string) {
    isExternalLink(url) ?  window.open(url) : this.router.navigate([url || '/']);
  }

  private checkingForMetadataProperty(object, property) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      return object[property];
    }
  }

  private checkingForRouteMetadata(data) {
    if (Object.keys(data).length !== 0) {
      this.contactEmail = this.checkingForMetadataProperty(data, 'contactEmail') || this.contactEmail;
      this.contactPhone = this.checkingForMetadataProperty(data, 'contactPhone') || this.contactPhone;
      this.reason = this.checkingForMetadataProperty(data, 'reason') || this.reason;
      this.urlBack = this.checkingForMetadataProperty(data, 'urlBack') || this.urlBack;
    }
  }

}
